import { Injectable } from '@angular/core';
import {LogLevel} from './log-level';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  appLogLevel = LogLevel.DEBUG;

  constructor()
  {
    this.appLogLevel = environment.logLevel;
  }

  _log(level: LogLevel, message?: any | (() => any), additional: any[] = []) {

    if (this.appLogLevel > level) { return; }

    message = this.convertToString([message]);
    const time = new Date().toLocaleTimeString();
    message = time + ': ' + message;

    switch (level) {
      case LogLevel.WARN:
        console.warn(message, ...additional);
        break;
      case LogLevel.ERROR:
        console.error(message, ...additional);
        break;
      case LogLevel.INFO:
        console.info(message, ...additional);
        break;
      case LogLevel.DEBUG:
        console.debug(message, ...additional);
        break;
      default:
        console.log(message, ...additional);
    }
  }

  private convertToString(additional: any[] = []) {
    let message = '';
    // I removed JSON Stringify since it can cause "converting circular structure to JSON" errors.
    // We could use this https://www.npmjs.com/package/flatted in a future version
    for (const element of additional) {
      message += element;
    }
    return message;
  }

  public debug(message?: any | (() => any), ...additional: any[]): void {
    this._log(LogLevel.DEBUG, message, additional);
  }
  public info(message?: any | (() => any), ...additional: any[]): void {
    this._log(LogLevel.INFO, message, additional);
  }
  public warn(message?: any | (() => any), ...additional: any[]): void {
    this._log(LogLevel.WARN, message, additional);
  }

  public log(message?: any | (() => any), ...additional: any[]): void {
    this._log(LogLevel.LOG, message, additional);
  }

  public error(message?: any | (() => any), ...additional: any[]): void {
    this._log(LogLevel.ERROR, message, additional);
  }

}
